/**
 * URL utilities for blockchain explorers
 */

export function getHivePostUrl(author: string, permlink: string): string {
  return `https://hive.blog/@${author}/${permlink}`;
}

export function getSteemitPostUrl(author: string, permlink: string): string {
  return `https://steemit.com/@${author}/${permlink}`;
}

export function getBlurtPostUrl(author: string, permlink: string): string {
  return `https://blurt.blog/@${author}/${permlink}`;
}

export function getHiveProfileUrl(author: string): string {
  return `https://hive.blog/@${author}`;
}

export function getSteemitProfileUrl(author: string): string {
  return `https://steemit.com/@${author}`;
}

export function getBlurtProfileUrl(author: string): string {
  return `https://blurt.blog/@${author}`;
}
